import * as React from 'react';
export default function Login() {
  return (
    <React.Fragment>

      <img alt="NetLib" style={{width:'100%'}} src="/images/Netlib-Home-Screen.png"/>
    </React.Fragment>
  );
}